import CacheState from './CacheState'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreScrollOnPageBack from './RestoreScrollOnPageBack'

export default {
    mixins: [CacheState, RestoreScrollOnPageBack],

    data() {
        return {
            componentWasRestored: false,
        }
    },

    created() {
        if (NavigationProvider.isRestored()) {
            this.componentWasRestored = this.loadState()
        }
    },

    methods: {
        onPageRestore(callback) {
            if (this.componentWasRestored) {
                callback()
            }
        },

        onPageVisit(callback) {
            if (!this.componentWasRestored) {
                callback()
            }
        },
    },
}
